import { render, staticRenderFns } from "./zDialogo.vue?vue&type=template&id=5a2438fe&scoped=true&"
import script from "./zDialogo.vue?vue&type=script&lang=js&"
export * from "./zDialogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2438fe",
  null
  
)

export default component.exports